export default "/images/gjensidige.webp?e78be82ef2c0cae7f3bee99224761005";